export const API_ENVS_FOR_APPS = [
  { label: 'Production', value: 'prod' },
  { label: 'Test', value: 'test' }
];


export const LATENCIES = [
  { label: 'P90', value: 'p90Latency', disabled: true }
];
export const ALL_APIS_OPTION = {
  label: 'All APIs',
  value: 'ALL_APIS'
};

export const TIME_SPANS = [
  { label: 'Last 10 min', value: '10m' },
  { label: 'Last 60 min', value: '60m' },
  { label: 'Last 24 hours', value: '24h' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 30 days', value: '30d' }
];

export const API_STATUS = {
  ACTIVE: 'active'
};